import React, { useState, useEffect, useMemo, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import { useDispatch, useSelector } from "react-redux";
import { getIndustry, getWithParentCategary } from "../../../../redux/categary/action";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import NumberInputBox from "../../../CustomComponents/AllCustomeInput/NumberInputBox";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import CustomReactQuill from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuill";
import { descriptionvalidation, nospecialtitle } from "../../../Common/commonvalidation";
import AsteriskLabel from "../../../Common/AsteriskLabel";
import CommonCategoryOption from "../../../Common/CommonCategoryOption";
import CommonIndustryOption from "../../../Common/CommonIndustryOption";
import CommonSubCategoryCreatable from "../../../Common/CommonSubCategoryCreatable";
import { disabledStyle } from "../../../Common/ClickDisable"; // Added import for disabled styles

const bxpDatatomap = [
  { title: (<>Product title <AsteriskLabel /></>), name: "title", placeholder: "Type here" },
  // { title: (<>Cover Image </>), name: "cover", placeholder: "Drag and drop or Browse file" },
  { title: (<>Description <AsteriskLabel /></>), name: "description", placeholder: "Type here" },
  { title: (<>Industry <AsteriskLabel /></>), name: "industry_id", placeholder: "Select industry" },
  { title: (<>Category <AsteriskLabel /></>), name: "category_id", placeholder: "Select Category" },
  { title: (<>Sub Category </>), name: "sub_category_id", placeholder: "Select Sub Category" },
  { title: (<>Price</>), name: "price", placeholder: "Enter price in SAR" },
];

const validationSchema = Yup.object().shape({
  title: nospecialtitle,
  industry_id: Yup.string().required("Industry is required"),
  category_id: Yup.string().required("Category is required"),
  price: Yup.number().required("Price is required").moreThan(0, "Price should be more than zero"),
  description: descriptionvalidation,
});

const SyncParent = ({ values, setbxpData, updateindex, initialValues, setChangesIsThere }) => {
  const lastSynced = useRef("");
  const initialSnapshot = useRef(null);

  if (initialSnapshot.current === null) {
    initialSnapshot.current = JSON.stringify(initialValues);
  }

  useEffect(() => {
    const currentValues = JSON.stringify(values);
    if (lastSynced.current !== currentValues) {
      if (updateindex === null && Object.keys(values).length > 0) {
        setbxpData((prev) => ({ ...prev, ...values }));
      }
      const hasChanges = currentValues !== initialSnapshot.current;
      setChangesIsThere(hasChanges);
      lastSynced.current = currentValues;
    }
  }, [values, updateindex, setbxpData, setChangesIsThere]);
  return null;
};

const Productdetails = ({ updateindex, bxpData, setbxpData, setActiveTab, setChangesIsThere }) => {
  const [loading, setLoading] = useState(false);
  const [isFileUploading, setIsFileUploading] = useState(false); // State to track image upload
  const [image, setImage] = useState(null);
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [selectCategory, setSelectCategory] = useState(null);
  const [selectSubcategory, setSelectSubcategory] = useState(null);
  const dispatch = useDispatch();

  const categarylist = useSelector((state) => state.categary.categarylist);
  const TheIndustryList = useSelector(({ categary: { industrylist } }) => industrylist);

  const initialValues = useMemo(() => {
    return {
      title: bxpData?.title || "",
      // cover: bxpData?.cover || "",
      industry_id: bxpData?.industry_id || "",
      category_id: bxpData?.category_id || "",
      description: bxpData?.description || "",
      sub_category_id: bxpData?.sub_category_id || "",
      price: bxpData?.price || "",
    };
  }, [bxpData]);

  useEffect(() => {
    if (updateindex) {
      setImage(null);
    }
  }, [updateindex]);

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
    dispatch(getIndustry());
  }, [path, dispatch]);

  useEffect(() => {
    if (bxpData?.industry_id) {
      setSelectedIndustry(bxpData?.industry_id);
    }
  }, [bxpData?.industry_id]);

  useEffect(() => {
    if (selectedIndustry) {
      dispatch(getWithParentCategary(selectedIndustry));
    }
  }, [selectedIndustry, dispatch]);

  useEffect(() => {
    if (bxpData?.category_id && categarylist?.length) {
      const selectedCategory = categarylist.find((item) => item.id == bxpData?.category_id);
      setSelectCategory(selectedCategory ? { value: selectedCategory.id, label: selectedCategory.title } : null);
    } else if (updateindex == null) {
      setSelectCategory(null);
    }
  }, [updateindex, bxpData?.category_id, categarylist]);

  useEffect(() => {
    if (bxpData?.sub_category_id && bxpData?.subcategory_index) {
      setSelectSubcategory(bxpData.subcategory_index);
    } else if (bxpData?.sub_category_id && bxpData?.sub_category_title) {
      setSelectSubcategory({ value: bxpData.sub_category_id, label: bxpData.sub_category_title });
    } else if (updateindex == null) {
      setSelectSubcategory(null);
    }
  }, [updateindex, bxpData?.sub_category_id, bxpData?.subcategory_index, bxpData?.sub_category_title]);

  const handleSubmit = async (values) => {
    setLoading(true);
    let updatedData = { ...bxpData, ...values };

    try {
      setbxpData(updatedData);
      setActiveTab("WorkSamples");
    } catch (error) {
      urtoast(error.message, 2);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  // Block submission if the form is processing or an image is actively uploading
  const isFormDisabled = loading || isFileUploading;

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              <SyncParent
                values={formik.values}
                setbxpData={setbxpData}
                updateindex={updateindex}
                initialValues={initialValues}
                setChangesIsThere={setChangesIsThere}
              />
              <div>
                {bxpDatatomap.map((prop, key) => {
                  // if (prop.name === "cover") {
                  //   return (
                  //     <div key={key}>
                     
                  //       <FieldInput
                  //         title={prop.title}
                  //         name={prop.name}
                  //         placeholder={prop.placeholder}
                  //       />
                  //       {isFileUploading && (
                  //         <div className="file-upload-loader mt-2 d-flex align-items-center gap-2">
                  //           <LoginLoaderButton />
                  //           <span style={{ fontSize: "14px", color: "#666" }}>Uploading cover image...</span>
                  //         </div>
                  //       )}
                  //     </div>
                  //   );
                  // }

                  if (prop.name === "description") {
                    return (
                      <React.Fragment key={key}>
                        <CustomReactQuill
                          value={formik.values[prop.name]}
                          formik={formik}
                          name={prop.name}
                          title={prop.title}
                        />
                        <ErrorMessage
                          name={prop.name}
                          component="div"
                          className="error"
                          style={{ color: "red" }}
                        />
                      </React.Fragment>
                    );
                  }

                  if (prop.name === "industry_id") {
                    return (
                      <CommonIndustryOption
                        key={key}
                        options={TheIndustryList}
                        formik={formik}
                        prop={prop}
                        setSelectedIndustry={setSelectedIndustry}
                        setSelectCategory={setSelectCategory}
                      />
                    );
                  }

                  if (prop.name === "category_id") {
                    return (
                      <React.Fragment key={key}>
                        <CommonCategoryOption
                          formik={formik}
                          prop={prop}
                          options={categarylist}
                          selectCategory={selectCategory}
                          setSelectCategory={setSelectCategory}
                          setSelectSubcategory={setSelectSubcategory}
                        />
                      </React.Fragment>
                    );
                  }

                  if (prop.name === "price") {
                    return (
                      <NumberInputBox
                        title={prop.title}
                        name={prop.name}
                        placeholder={prop.placeholder}
                        key={key}
                      />
                    );
                  }

                  if (prop.name === "sub_category_id") {
                    if (formik.values.category_id) {
                      return (
                        <CommonSubCategoryCreatable
                          key={key}
                          formik={formik}
                          prop={prop}
                          categoryId={formik.values.category_id}
                          selectSubcategory={selectSubcategory}
                          setSelectSubcategory={setSelectSubcategory}
                        />
                      );
                    } else return null;
                  }

                  return (
                    <FieldInput
                      title={prop.title}
                      name={prop.name}
                      placeholder={prop.placeholder}
                      key={key}
                    />
                  );
                })}

                <div className="button-container">
                  <button 
                    className="next-button w-100" 
                    type="submit"
                    disabled={isFormDisabled}
                    style={isFormDisabled ? disabledStyle : {}}
                  >
                    {loading ? <LoginLoaderButton /> : "Next"}
                  </button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default Productdetails;